import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-14e6fa17")

_pushScopeId("data-v-14e6fa17")
const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex alignC top-button-group" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "新增员工", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "状态", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "部门", -1)
const _hoisted_6 = {
  class: "flex",
  style: {"align-items":"center","justify-content":"center"}
}
const _hoisted_7 = { class: "flex flexR mar-t-22" }
const _hoisted_8 = { class: "dialog-footer" }
const _hoisted_9 = { class: "c-ff" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "取 消", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.roleList.create)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            class: "bg-red",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialog_show = true))
          }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _hoisted_4,
      _createVNode(_component_el_select, {
        class: "mar-r-8",
        style: {"width":"108px"},
        modelValue: _ctx.screenParameter.status,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.screenParameter.status = $event)),
        onChange: _ctx.selectChange,
        placeholder: "请选择",
        clearable: ""
      }, {
        default: _withId(() => [
          _createVNode(_component_el_option, {
            label: "启用",
            value: "1"
          }),
          _createVNode(_component_el_option, {
            label: "禁用",
            value: "0"
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      _hoisted_5,
      _createVNode(_component_el_select, {
        class: "mar-r-8",
        style: {"width":"108px"},
        modelValue: _ctx.screenParameter.branch_id,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.screenParameter.branch_id = $event)),
        onChange: _ctx.selectChange,
        placeholder: "请选择",
        clearable: "",
        filterable: ""
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.form_branchList, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              label: item.branch_name,
              value: item.branch_id
            }, null, 8, ["label", "value"]))
          }), 256))
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      _createVNode(_component_el_input, {
        class: "mar-l-16",
        modelValue: _ctx.screenParameter.search,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.screenParameter.search = $event)),
        placeholder: "单据编号/配件/实际采购",
        "suffix-icon": "el-icon-search",
        style: {"width":"220px"},
        onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectChange($event)))
      }, null, 8, ["modelValue"])
    ]),
    _createVNode("div", null, [
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.tableData,
        stripe: "",
        style: {"width":"100%"},
        class: "table",
        "header-cell-style": _ctx.headClass
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              align: "center",
              prop: item.prop,
              label: item.label,
              "min-width": item.width,
              key: index
            }, null, 8, ["prop", "label", "min-width"]))
          }), 128)),
          _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center",
            "min-width": "150"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_6, [
                (_ctx.roleList.reset_psd)
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      class: "btn-red",
                      onClick: ($event: any) => (_ctx._resetPassword(scope.row.id))
                    }, " 重置密码 ", 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.roleList.edit)
                  ? (_openBlock(), _createBlock("div", {
                      key: 1,
                      class: "btn-red-line mar-l-2",
                      onClick: ($event: any) => (_ctx.edit(scope.row.id))
                    }, " 修改 ", 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.roleList.disable)
                  ? (_openBlock(), _createBlock("div", {
                      key: 2,
                      class: scope.row.status == 0?'btn-grey-line mar-l-2':'btn-red-line mar-l-2',
                      onClick: ($event: any) => (
                                    _ctx._uprowStatus(scope.row.id, scope.row.status)
                                )
                    }, _toDisplayString(scope.row.status == 0 ? "启用" : "禁用"), 11, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "header-cell-style"]), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.currentPage,
        "page-sizes": [10,20,50,100],
        "page-size": _ctx.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      title: `${_ctx.isEdit ? '编辑' : '新增'}员工`,
      modelValue: _ctx.dialog_show,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.dialog_show = $event)),
      center: ""
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_8, [
          _createVNode(_component_el_button, {
            class: "bg-red",
            onClick: _ctx.submitForm
          }, {
            default: _withId(() => [
              _createVNode("span", _hoisted_9, _toDisplayString(_ctx.isEdit ? "保存" : "立即创建"), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.dialog_show = false))
          }, {
            default: _withId(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _withDirectives(_createVNode(_component_el_form, {
          model: _ctx.form,
          ref: "formRef",
          inline: true,
          rules: _ctx.formRules,
          "label-width": "100px"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: "登录账号",
              prop: "name"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  class: "dialog-input",
                  modelValue: _ctx.form.name,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.name = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "角色权限",
              prop: "role_id"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.form.role_id,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.role_id = $event)),
                  placeholder: "请选择"
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.form_roleList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.role_name,
                        value: item.role_id
                      }, null, 8, ["label", "value"]))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "手机号码",
              prop: "phone"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  class: "dialog-input",
                  modelValue: _ctx.form.phone,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.phone = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "所属部门",
              prop: "branch_id"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.form.branch_id,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.branch_id = $event)),
                  placeholder: "请选择"
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.form_branchList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.branch_name,
                        value: item.branch_id
                      }, null, 8, ["label", "value"]))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "姓名",
              prop: "nickname"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  class: "dialog-input",
                  modelValue: _ctx.form.nickname,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.nickname = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "身份证号码" }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  class: "dialog-input",
                  modelValue: _ctx.form.identity_number,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.identity_number = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "职位",
              prop: "position_id"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.form.position_id,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.form.position_id = $event)),
                  placeholder: "请选择"
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.form_positionList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.position_name,
                        value: item.position_id
                      }, null, 8, ["label", "value"]))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "入职日期",
              prop: "entry_time"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.form.entry_time_text,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form.entry_time_text = $event)),
                  type: "date",
                  placeholder: "选择日期",
                  onChange: _ctx.entryTimeChange
                }, null, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "性别",
              prop: "gender"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.form.gender,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.form.gender = $event)),
                  placeholder: "请选择"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_option, {
                      label: "男",
                      value: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "女",
                      value: 2
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "住址" }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  class: "dialog-input",
                  modelValue: _ctx.form.address,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.form.address = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "QQ" }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  class: "dialog-input",
                  modelValue: _ctx.form.qq,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.form.qq = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "微信" }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  class: "dialog-input",
                  modelValue: _ctx.form.wechat,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.form.wechat = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"]), [
          [_directive_loading, _ctx.form_isload]
        ])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]))
})